import React from "react";
import styled from "styled-components";
import { colors } from "../common/mixins.js";

const StyledIcon = styled("i")((props) => ({
  display: "flex",
  alignItems: "center",
  width: props.width || "24px",
  height: props.height || "24px",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  ...(props.kind === "warning-colored" && {
    backgroundImage:
      'url("/Site/images/icons/order-details/warning-colored.svg")',
  }),
  ...(props.kind === "exclamation-icon" && {
    backgroundImage:
      'url("/Site/images/icons/order-details/exclamation-icon.svg")',
  }),
}));

const Container = styled("div")(
  ({ isDelayedTicketDelivery, isGovWalletInfo }) => ({
    width: "100%",
    display: "flex",
    gap: "8px",
    alignItems: "center",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: isDelayedTicketDelivery
      ? colors.lightPrimary
      : isGovWalletInfo
      ? "#fff"
      : colors.warningAlert,
    color: "#1f1c43",
    fontSize: "14px",
    fontWeight: "400",
    justifyContent: "space-between",
    border: isDelayedTicketDelivery ? "1px solid #502CB5" : "1px solid #fcb041",
    fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
    },
  })
);

const PayButton = styled("button")({
  minWidth: 90,
  height: 37,
  fontSize: 14,
  borderRadius: 24,
  backgroundColor: "#FFFFFF",
  border: "1px solid #EDF1F6",
  fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
  padding: "8px 16px",
  fontWeight: 600,
  color: "#2F1A6B",
  "&:hover": {
    border: "1px solid #D8DBE0",
  },
  "&:active": {
    border: "1px solid #EDF1F6",
    backgroundColor: "#F7F9FB",
  },
});

const Content = styled("div")({
  display: "flex",
  gap: 8,
  "& > :first-child": {
    flexShrink: 0,
  },
  "@media (max-width: 768px)": {
    alignItems: "start",
  },
});

const Title = styled("div")(({ isGovWalletInfo }) => ({
  fontWeight: 600,
  marginBottom: 4,
  ...(isGovWalletInfo && { fontSize: "20px" }),
}));

const Description = styled("div")(({ isGovWalletInfo }) => ({
    paddingRight: 16,
  ...(isGovWalletInfo && { fontSize: "16px" }),
}));

const Link = styled("a")({
  color: "#703EFF",
  fontWeight: 600,
  cursor: "pointer",
  fontSize: 14,
  textDecoration: "none",
  "&:hover": {
    color: "#502CB5",
  },
});

const Button = styled("div")({
  marginLeft: "auto",
  "@media (max-width: 768px)": {
    marginLeft: 32,
    width: "100%",
  },
});

const Img = styled("img")({
  "@media (max-width: 768px)": {
    margin: "0 auto",
  },
});

const WarningInfo = ({
  isUnpaidServiceFee,
  isUnpaidDonation,
  isDelayedTicketDelivery,
  isGovWalletInfo,
  orderId
}) => {
 
  const title = isUnpaidServiceFee
      ? orderdetails_resources.ServiceFeeFailed
      : isUnpaidDonation
    ? "The payment of the donation was not completed!"
    : isDelayedTicketDelivery
    ? "Delayed ticket delivery"
    : "";
  const description = isUnpaidServiceFee
      ? orderdetails_resources.ServiceFeeFailedDescription
    : isUnpaidDonation
    ? "Although the ticket payment was successful, the payment of the donation failed. Please complete the payment in order to download your ticket."
    : isDelayedTicketDelivery
    ? "You will be able to access your tickets on 22/03, 22:00. Don’t worry, we will also send you an email reminder when they are available for download!"
    : "";

    const handleClick = (e) => {
        e.preventDefault();
        const baseUrl = window.location.origin;
        if (isUnpaidServiceFee) {
            window.open(`${baseUrl}/_api/reservations/handle-service-fee/${orderId}`, "_blank");
        }
        if (isUnpaidDonation) {
            console.log("donation");
        } 
    }
  return (
    <Container
      isDelayedTicketDelivery={isDelayedTicketDelivery}
    >
      <Content>
        <StyledIcon
          kind={
            isDelayedTicketDelivery ? "exclamation-icon" : "warning-colored"
          }
        />
        <div>
                  <Title  isUnpaidServiceFee={isUnpaidServiceFee} isDelayedTicketDelivery={isDelayedTicketDelivery} isUnpaidDonation={isUnpaidDonation}>{title}</Title>
                  <Description
                      isUnpaidServiceFee={isUnpaidServiceFee}
                      isUnpaidDonation={isUnpaidDonation}
                      isDelayedTicketDelivery={isDelayedTicketDelivery}
                      dangerouslySetInnerHTML={{ __html: description }}
                  >
          </Description>
        </div>
      </Content>     
        <Button>
          {!isDelayedTicketDelivery && (
            <PayButton onClick={handleClick}>
             {orderdetails_resources.Pay}
            </PayButton>
          )}
        </Button>
    </Container>
  );
};

export default WarningInfo;
